<template>
    <div>
        <div class="d-flex flex-wrap explain pb-3">
            <b-badge variant="success" class="mr-1" pill></b-badge> {{ 'guessed_symbols' | lang }}
            <b-badge variant="dark" pill class="ml-2 mr-1"></b-badge> {{ 'selected_symbols' | lang }}
        </div>
        <b-table-simple responsive>
            <b-thead head-variant="dark">
                <b-tr>
                    <b-th class="hidden-row"></b-th>
                    <b-th v-for="{ count } in itemsCounts" :key="count">{{ count }}</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(guessed, index) in guessNumbers" :key="guessed">
                    <b-td :variant="index % 2 ? 'success-light' : 'success'">{{ guessed }}</b-td>
                    <b-td :variant="index % 2 ? 'light' : ''" v-for="{ count, multiplier, sharing } in itemsCountsByGuessed(guessed)" :key="count">{{ multiplier }} {{ sharing ? '*' : '' }}</b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
        <div>
            <span class="text-danger">*</span>
            <span>{{ 'rules.if_more_winners' | lang }}</span>
            <div class="mt-2">
                <b>{{ 'rules.how_are_calculated' | lang }}</b>
                <div>{{ 'rules.multi_instruction_1' | lang }}. {{ 'rules.multi_instruction_2' | lang }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['game'],

    computed: {
        itemsCounts() {
            return this.game.counts;
        },

        guessNumbers() {
            const values = Object.values(this.game.guesses_values)
                .map(item => item.guessed);
            
            return [ ...new Set(values) ].reverse();
        },
    },

    methods: {
        itemsCountsByGuessed(guessedNumber) {
            const guessed = [];

            for (const [ countId, { count } ] of Object.entries(this.itemsCounts)) {
                for (const guessValue of Object.values(this.game.guesses_values)) {
                    if (guessValue.guessed == guessedNumber && countId == guessValue.count_id) {
                        guessed.push({ ...guessValue, count });
                    }
                }
            }

            return guessed;
        },
    },
}
</script>